import { Component, inject, model, ChangeDetectionStrategy } from '@angular/core';
import { IEmpleadoData } from '@core/interfaces/entidades/empleado.entidad';
import { InicialesNombrePipe } from '../../pipes/iniciales-nombre.pipe';
import { EmpleadoApiService } from '@core/services/api/empleado-api.service';
import { ToastService } from '@shared/services/toast.service';
import { UiDialog } from '@shared/components/ui';
import { EditarEmpleado } from './editar-empleado/editar-empleado';
import { TelefonoPipe } from '../../pipes/telefono.pipe';

@Component({
  selector: 'app-card-empleado',
  imports: [InicialesNombrePipe, UiDialog, EditarEmpleado, TelefonoPipe],
  templateUrl: './card-empleado.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './card-empleado.css',
})
export class CardEmpleado {
  // servicios
  private empleadoApiService = inject(EmpleadoApiService);
  private toastService = inject(ToastService);
  // data
  modal_editar_empleado = model(false);
  empleado = model.required<IEmpleadoData>();

  get permisos(): string {
    // return this.empleado().permisos.join(', ');
    return 'Múltiples permisos';
  }

  onStatus(activar: boolean): void {
    if (activar) {
      if (this.empleado().deleted_at) {
        this.empleadoApiService.desbloquear(this.empleado().id).subscribe({
          next: () => {
            this.empleado.update((r) => ({ ...r, deleted_at: undefined }));
            this.toastService.show(
              'top-right',
              'success',
              'Empleado desbloqueado',
              'El empleado ha sido desbloqueado correctamente.',
            );
          },
          error: (err) => {
            if (err.status == 401) return;
            this.toastService.show(
              'top-right',
              'error',
              'Error',
              err.error.message || 'No se pudo desbloquear el empleado.',
            );
          },
        });
      }
    } else {
      if (!this.empleado().deleted_at) {
        this.empleadoApiService.bloquear(this.empleado().id).subscribe({
          next: () => {
            this.empleado.update((r) => ({ ...r, deleted_at: new Date() }));
            this.toastService.show(
              'top-right',
              'success',
              'Empleado bloqueado',
              'El empleado ha sido bloqueado correctamente.',
            );
          },
          error: (err) => {
            if (err.status == 401) return;
            this.toastService.show(
              'top-right',
              'error',
              'Error',
              err.error.message || 'No se pudo bloquear el empleado.',
            );
          },
        });
      }
    }
  }

  closeEditarEmpleado(updatedEmpleado?: IEmpleadoData) {
    this.modal_editar_empleado.set(false);
    if (updatedEmpleado) {
      this.empleado.set(updatedEmpleado);
    }
  }
}